export default __webpack_public_path__ + "static/media/login-page-background.3338702b.png";